<template>
    <div>
        <b-row>
            <span>{{ label }}</span>
        </b-row>
        <b-row>
            <!-- Loop through the colors array and create a color sample for each one -->
            <span v-for="(color, index) in colors" :key="index"
                class="colorsample"
                :style="{ backgroundColor: color }"
                :class="{ 'selected': selectedColor === color }"
                @click="toggle(color)">
                <!-- Add a checkmark or highlight when the color is selected -->
                <span v-if="selectedColor === color" class="checkmark">✔</span>
            </span>
        </b-row>
    </div>
  </template>
  
  <script>
  export default {
    name: "p-color-picker",
    data() {
      return {
        // Observable to store the selected color
        selectedColor: null,
      };
    },
    computed: {
        value() { return this.modelValue; },
    },
    watch: {
        value: {
            handler: function(newVal) {
                this.selectedColor = newVal;
            }
        }
    },
    props: {
        modelValue: { default: null },
        // value prop now comes from modelValue computed
        label: {
            type: String,
            default: "Color"
        },
        colors: {
            type: Array,
            default: () => ["#1f3f1f", "#3f1f1f", "#3c113f", "#fa743e", "#4c516d", "#4a913c","#3b94d9", "#dd2e44", "#9266cc"]
        }
    },
    methods: {
      // Set the selected color
      toggle(color) {
        if(color == this.selectedColor)
        {
            this.selectedColor = null;
        }else{
            this.selectedColor = color;
        }
        
        this.$emit('update:modelValue', this.selectedColor);
        this.$emit('input', this.selectedColor);
      }
    },
    created() {
        this.selectedColor = this.value;
    }
  };
  </script>
  
  <style scoped>
  /* Style for color sample squares */
  .colorsample {
    width: 30px;
    height: 30px;
    margin: 5px;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    border: 2px solid transparent;position: relative;
}

/* When a color is selected, highlight with a border */
.colorsample.selected {
  border-color: black;
}

/* Style the checkmark icon inside the color sample */
.checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: white;
}
  </style>
  